import { StoreState } from '../store-interfaces';
import ConnectionModel from '../model/ConnectionModel';

export const selectWidgetGoogleConnections = (state: StoreState) =>
  state.connections.widgetGoogleConnections ?? [];

export const selectWidgetFacebookAudienceConnections = (state: StoreState) =>
  state.connections.widgetFacebookAudienceConnections ?? [];

export const getActiveWidgetGoogleConnections = (state: StoreState) => {
  const sheets = state.connections.widgetGoogleConnections ?? [];
  return sheets.filter((connection: ConnectionModel) => connection.active);
};

export const selectCrmsLeadsSent = (state: StoreState) =>
  state.connections.crmsLeadsSent;

export const selectWebhookJsonTemplates = (state: StoreState) =>
  state.connections.webhookJsonTemplates;
